import { isLocalUrl } from '../localjs';

export default function () {
  const widgetName = 'seoWidget';
  const widgetOpts = seoWidgetOpts;
  const $widget = $(`#${widgetName}`);

  const animationSettings =
    'data-aos="fade-right" data-aos-easing="ease-in-out" data-aos-duration="2000" data-aos-delay="150" data-aos-once="true" data-aos-offset="200"';

  $widget.wrap(
    `<div class="seo-container"><div class="inner-container aos-init" ${animationSettings}></div></div>`,
  );

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    textOverImage: false,
    itemsPerPanel: 1,
    maxItemsVisible: 1,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (!hasData) {
        $widget.remove();
        $('.video-seo-container').addClass('no-seo');
      } else {
        $widget.parent().append('<div class="snow-effect"></div>');
        $widget.parent().append('<div class="snow-effect-two"></div>');
        $widget.closest('.seo-container').append(`
          <div class="seo-graphic">
            <div class="seo-girl"></div>
            <div class="seo-snow"></div>
          </div>`);
        createCustomSeo(data.items);
      }
    },
  });

  function createCustomSeo(widgetData) {
    const $seo = $widget.find('.card-widget-item');
    const { Title, Description, URL, DetailLinkText } = widgetData[0];

    $seo.replaceWith(`
      <h1 class="seo-title" aria-label="${Title} ${DetailLinkText != 'More' ? DetailLinkText : ''}">
        ${DetailLinkText != 'More' ? `<span class="upper-title">${DetailLinkText}</span>` : ''}
        <span class="main-title">${Title}</span>
      </h1>
      <div class="seo-description">${Description}</div>
      <a href="${URL}" class="button"  ${isLocalUrl(URL) ? '' : "target='_blank'"}>Learn More</a>
    `);

    addAnimations();
  }
}

function addAnimations() {
  $('.seo-container .seo-girl').attr({
    'data-aos': 'fade-left',
    'data-aos-easing': 'ease-in-out',
    'data-aos-duration': '1000',
    'data-aos-delay': '1000',
    'data-aos-once': 'true',
    'data-aos-offset': '200',
  });

  $('.seo-container .seo-snow').attr({
    'data-aos': 'zoom-in-left',
    'data-aos-easing': 'ease-in-out',
    'data-aos-duration': '1000',
    'data-aos-delay': '1500',
    'data-aos-once': 'true',
    'data-aos-offset': '200',
  });
}
